import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateIsBlacklistError = new ReduxAsyncAction<'UPDATE_IS_BLACKLIST_ERROR', boolean, { isBlacklistError: boolean }>(
  'UPDATE_IS_BLACKLIST_ERROR'
);

UpdateIsBlacklistError.registerRequest(async (isBlacklistError: boolean) => {
  return { isBlacklistError };
});

export const UPDATE_IS_BLACKLIST_ERROR = UpdateIsBlacklistError.actionNamespaceConstants;
export const updateIsBlacklistError = UpdateIsBlacklistError.request;

export type UpdateIsBlacklistErrorResponseAction = Action<typeof UPDATE_IS_BLACKLIST_ERROR.response> & {
  data: { isBlacklistError: boolean };
};
